import { FaChartBar, FaDownload } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { Button, Page, PageHeader } from '../ui'
import { ViewThruBatchView } from '../components/views/viewThruBatchView'
import { VIEWTHRU_ALL_BATCHES_PATH } from './viewThruAllBatches'

/** Headers the batch parser expects (matches the Sentinel spreadsheet template). */
const TEMPLATE_HEADERS = [
    'Title',
    'First Name',
    'Last Name',
    'Date of Birth',
    'Phone',
    'Email',
    'Postcode',
    'Building Number',
    'Building Name',
    'Street',
    'Town/City'
]

const downloadTemplate = () => {
    const csv = `\uFEFF${TEMPLATE_HEADERS.join(',')}\n`
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'viewthru-batch-template.csv'
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
}

function ViewThruBatch() {
    const navigate = useNavigate()
    return (
        <div className="viewThruBatch">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Sentinel Tools"
                        title="ViewThru Batch"
                        intro="Upload client spreadsheets to run ViewThru credit checks in bulk and review each batch's eligibility results."
                        actions={
                            <>
                                <Button variant="neutral" size="sm" onClick={() => navigate(VIEWTHRU_ALL_BATCHES_PATH)}>
                                    <FaChartBar /> Analyse all batches
                                </Button>
                                <Button variant="neutral" size="sm" onClick={downloadTemplate}>
                                    <FaDownload /> Batch Template
                                </Button>
                            </>
                        }
                    />
                    <ViewThruBatchView />
                </Page>
            </MainView>
        </div>
    )
}

export default ViewThruBatch
